import React from 'react';
import { Box, Fab, Icon, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ChatTALI from './Components/ChatTALI';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'fixed',
        right: 20,
        top: '80%',
        transform: 'translateY(-50%)',
        width: 70,
        height: 70,
        zIndex: theme.zIndex.modal + 1,
        [theme.breakpoints.down('sm')]:{
          right: 15,
          top: '50%',
          transform: 'translateY(-50%)',
        },
    },
    icon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: theme.palette.primary.main,
        borderRadius: '50%',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
            cursor: 'pointer',
            transform: 'scale(1.1)',
            backgroundColor: theme.palette.primary.dark,
            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.25)',
        },
        '& .ri-chat-smile-2-fill': {
            fontSize: '28px',
            color: 'white',
        },
    },
    modal: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        width: '100%',
        height: '100%',
        padding: '20px',
        [theme.breakpoints.down('sm')]: {
            padding: '10px',
        },
    },
}));
const AssistantTALI = () => {
    const classes = useStyles();
    const [openModal, setOpenModal] = React.useState(false);
    const handleModalTALI = (event) => {
        event.stopPropagation();
        console.log('openModal', openModal);
        setOpenModal(!openModal);
    }
    
    return (
        <>
            <Box className={classes.root}>
                <Fab className={classes.icon} onClick={handleModalTALI} aria-label="chat" id="talisis_assistant_tali_button">
                    {!openModal && <Icon className='ri-chat-smile-2-fill' />}
                    {openModal && <Icon className='ri-arrow-right-s-line text-white' />}
                </Fab>
            </Box>
            <Modal open={openModal} onClose={() => setOpenModal(false)} disableBackdropClick aria-label="chat">
                <Box className={classes.modal}>
                    <ChatTALI />
                </Box>
            </Modal>
        </>
    );
};

export default AssistantTALI;